/* eslint-disable import/prefer-default-export */
export const ROOT_SLICE = 'BulkSurveysModify';

export const JOB_LIST_TAB_KEYS = {
	FILTER: 'FILTER',
	SEARCH: 'SEARCH',
	EDIT_JOB: 'EDIT_JOB',
	CREATE_JOB: 'CREATE_JOB',
}